import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { TabModel } from '../common/types/TabModel';
import { AppStoreProvider } from './stores';
import BlazorForm from './components/BlazorForm/BlazorForm';

interface Props {
    tab: TabModel;
}

const CustomBlazorApp: React.FC<Props> = ({ tab }) => {
    return (
        <AppStoreProvider tab={tab}>
            <BlazorForm tab={tab} />
        </AppStoreProvider>
    );
};

export default observer(CustomBlazorApp);
